// extracted by mini-css-extract-plugin
module.exports = {"inputBlock":"inputBlock-1x0E0MR1ApY5R5h-1TMBnQ","label":"label-5TjMD62sX6OFRIhGpl7VQ","inline":"inline-Iogb2GN3A-GrBLm3-XIA9","value":"value-3NeFzjNuCpzRM7Ehbg8Qnx"};